import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate, Link } from 'react-router-dom';
import Logo from '../brand/Logo';
import apiService from '../../services/apiService';
import './Auth.css';

const SignUp = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: { email: '', password: '', confirmPassword: '', firstName: '', lastName: '' },
    validationSchema: Yup.object({
      firstName: Yup.string().required('Required'),
      lastName: Yup.string().required('Required'),
      email: Yup.string().email('Invalid email address').required('Required'),
      password: Yup.string().min(8, 'Must be at least 8 characters').required('Required'),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Required'),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        setError(null);
        await apiService.signUp({
          email: values.email,
          password: values.password,
          first_name: values.firstName,
          last_name: values.lastName,
        });
        setSuccess(true);
        setTimeout(() => navigate('/admin/signin'), 2000);
      } catch (err) {
        setError(err.message || 'Failed to sign up');
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="auth-page">
      <Link to="/" className="auth-logo-link">
        <Logo size="md" />
      </Link>

      <div className="auth-card">
        <h1 className="auth-card-title">Create account</h1>
        <p className="auth-card-sub">Join RGV Smart Pay</p>

        {error   && <div className="auth-error">{error}</div>}
        {success && <div className="auth-error" style={{background:'#f0fdf4',borderColor:'#bbf7d0',color:'#166534'}}>Registration successful! Redirecting...</div>}

        <form onSubmit={formik.handleSubmit} noValidate>
          {[
            { id: 'firstName', label: 'First Name', type: 'text', placeholder: 'First name', autoComplete: 'given-name' },
            { id: 'lastName',  label: 'Last Name',  type: 'text', placeholder: 'Last name',  autoComplete: 'family-name' },
            { id: 'email',     label: 'Email',      type: 'email', placeholder: 'you@example.com', autoComplete: 'email' },
            { id: 'password',         label: 'Password',         type: 'password', placeholder: '••••••••', autoComplete: 'new-password' },
            { id: 'confirmPassword',  label: 'Confirm Password', type: 'password', placeholder: '••••••••', autoComplete: 'new-password' },
          ].map(f => (
            <div className="auth-field" key={f.id}>
              <label htmlFor={f.id}>{f.label}</label>
              <input
                id={f.id}
                name={f.id}
                type={f.type}
                autoComplete={f.autoComplete}
                placeholder={f.placeholder}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values[f.id]}
              />
              {formik.touched[f.id] && formik.errors[f.id] && (
                <div className="auth-field-error">{formik.errors[f.id]}</div>
              )}
            </div>
          ))}

          <button type="submit" className="auth-submit" disabled={loading}>
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>
      </div>

      <div className="auth-footer-link">
        Already have an account? <Link to="/admin/signin">Sign In</Link>
      </div>
    </div>
  );
};

export default SignUp;
